import { gql } from '@apollo/client';

/**
 * Fragment canónico de Action — superset de los subselects usados por las
 * mutations legacy (CREATE_NEW_ACTION, UPDATE_ACTION, UPDATE_ACTION_RELATIONSHIPS).
 *
 * Se usa en la respuesta de `SAVE_ACTION` para que Apollo normalice la celda
 * `Action:<id>` con todos los campos que los componentes y queries consumen
 * (evita warnings "missing field X" en cache). Ver PLAN-SAVE-ENTITY-UNIFIED.md
 * §2.4 "Coexistencia de cache durante la migración".
 */
export const NEW_ACTION = gql`
  fragment NewAction on Action {
    id

    # ─── Índices + estado ───
    indexExpedition
    indexType
    state
    descriptionValidated

    # ─── Tipo B denormalizado (coherente con Order paralela) ───
    concessionIDs
    roadIDs
    teamIDs
    pkInitKm
    pkInitMeter
    pkEndKm
    pkEndMeter
    track
    direction
    margin
    lane
    predefinedOrderIDs
    creationDate
    registerInitDate
    registerArrivalDate

    # ─── Nav Trabajo/Revisión — contenedor D0 denormalizado (Fase 4 nav,
    # follow-up T4 2026-07-12): "Origen" de la tabla global de Actuaciones se
    # lee directo de este campo, sin lookup client-side por fila. Ver
    # gql/selectors/actions.ts → selectActionOrders.
    containerType

    # ─── Tipo C exclusivos Action ───
    typeOfHour
    minutesTotals
    isSimultaneous
    laneCutting
    # Corte de carril EFECTIVO calculado por el backend (flag OR actividad OR
    # OT predefinida). Es lo que se PINTA. Puede venir null en una fila creada
    # o editada sin cobertura: el selector cae entonces al cálculo local.
    isLaneCut
    assetSwitch
    isExternal

    # ─── Relaciones M:N (gestionadas con UPDATE_ACTION_RELATIONSHIPS) ───
    userIDs
    geoPositionActionIDs
    vehicleOccupantIDs
    workVehicleIDs
    activityIDs
    assetIDs
    materialUnitIDs
    # Materiales aplanados por el backend, para la columna y el filtro. Solo los
    # IDS: los nombres se resuelven contra el catálogo ya cacheado
    # (fetchMaterialsCatalog), así que renombrar un material en Gestión no
    # desincroniza ninguna fila guardada.
    materialIds
    hasMaterials
    auxMachineUnitIDs
    animalUnitIDs
    actionBudgetItemIDs
    externalWorksIDs

    # ─── Entidad doble ───
    orderIDs
  }
`;
